import { render, staticRenderFns } from "./GlobalButtonRemove.vue?vue&type=template&id=08b76b23"
import script from "./GlobalButtonRemove.vue?vue&type=script&lang=js"
export * from "./GlobalButtonRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports